import {apiV2SendTransactionCallback} from "../../../../../api/merchant/transactions";

const React = require('react');
const formatNum = require('mn-utils/formatNum');
const upperFirst = require('mn-utils/upperFirst');
const formatTime = require('mn-utils/formatTime');
import LinkIcon from '@material-ui/icons/Link';
import {openPopupInfo} from "../../../../../emitters/popup";
import {apiV2SendAdminTransactionCallback} from "../../../../../api/admin/transactions";
const {pushLocation} = require('../../../../../router');
const isOrderExpired = require('../../../../../utils/isOrderExpired');
const toEllipsisMiddle = require('../../../../../utils/toEllipsisMiddle');
const formatNumCurrency = require('../../../../../utils/formatNumCurrency');
const {LINK_ADMIN_TRANSACTIONS_DETAILS} = require('../../../../../constants/links');
const paymentTypes = require('../../../../../constants/paymentTypes');
const Tooltip = require('../../../../dumb/Tooltip/B');
const MenuForItem = require('../../../../dumb/Menu/ForItem');

module.exports = ({data}) => {
  const merchant = data.merchant || {};

  const status = data.state;

  return (
    <div
      className={`w layoutRow fhaS fvaC h60 bxzBorderBox rlv lh fw7 f12 c2 tl lts0em
                    (wmin130|w1/9|pt19|pr10|pb23|pl19)>1 bgF bb1 bsbS bcbE8E8E8`}
    >
      <div>
        <Tooltip className="fhaS">
          {data.id}
        </Tooltip>
      </div>
      <div className="f10">
        {formatTime(data.created_at, '{dd} {mmm}, {yyyy} {hh}:{MM}:{ss} {TT}')}
      </div>
      <div className="break">{merchant.name || '-'}</div>
      <div>
        <Tooltip className="fhaS">
          {data.customer_email}
        </Tooltip>
      </div>
      <div>{paymentTypes[data.payment_method] || upperFirst(data.payment_method)}</div>
      <div>
        <Tooltip className="fhaS" title={data.fiat_amount}>
          {formatNumCurrency(data.fiat_amount)} {data.fiat_code}
        </Tooltip>
      </div>
      <div>
        <Tooltip className="fhaS" title={data.crypto_amount}>
          {formatNum(data.crypto_amount, 8)} {data.cc_code}
        </Tooltip>
      </div>
      {/* <div>{data.fee_pg} {data.fee_code}</div>*/}
      {/* <div>{data.fee_lunu_pg} {data.fee_code}</div>*/}
      {/* <div>{data.fee_lunu_ret} {data.fee_code}</div>*/}
      <div>
        {data.transaction_id ? (
          <div className="layoutRow">
            <Tooltip className="fhaS" title={data.transaction_id}>
              {toEllipsisMiddle(data.transaction_id, 8)}
            </Tooltip>
            <a
              href={data.wallet_explorer}
              target="_blank"
              rel="noopener"
              className="ml20 o50:h dn"
            >
              <LinkIcon />
            </a>
          </div>
        ) : '-'}
      </div>
      <div>
        <span className={`c0 cFFBF43.created cFFBF43.confirmed c2CE889.completed
                c9C8FFF.requested c717275.expired cEE4F4F.cancelled cEE4F4F.failed ${status}`}>
          {status.toUpperCase()}
        </span>
        <MenuForItem items={[
          {
            name: 'Details', onClick() {
              pushLocation({
                path: `${LINK_ADMIN_TRANSACTIONS_DETAILS}/${data.id}`,
              });
            },
          },
          {
            name: 'Send callback', onClick() {
              apiV2SendAdminTransactionCallback(data.id).then(() => openPopupInfo(['We\'ve sent a callback for this transaction']));
            }
          }
        ].filter((el) => el)}/>
      </div>
    </div>
  );
};
